import { Navigation } from "@/components/Navigation";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { WhatsAppButton } from "@/components/WhatsAppButton";

const Kontakt = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Kontakt in Herford: 24h Rückruf für Ihre Sanierung"
        description="Kontakt Malerfachbetrieb Stein in Herford: Kostenlose Beratung vor Ort, 24h Rückruf-Service, WhatsApp & Telefon. Jetzt Termin vereinbaren ☎ 05221 3832130"
        keywords="Kontakt Maler Herford, Termin Malerfachbetrieb Herford, Anfrage Fassadensanierung Herford, kostenlose Beratung Herford, 24h Rückruf"
        canonical="https://malerfachbetrieb-stein.de/kontakt"
      />
      <Navigation />
      <WhatsAppButton />
      <main className="pt-32">
        <Contact variant="light" />
      </main>
      <Footer />
    </div>
  );
};

export default Kontakt;
